import type { RouteLocationNormalized } from 'vue-router'
import { InsertRowLeftOutlined } from '@ant-design/icons-vue'

export default [
  {
    path: '/emergencyMan',
    name: 'emergencyMan',
    redirect: '/emergencyMan/emergencyRes',
    meta: {
      title: '应急管理',
      sort: 1,
      icon: InsertRowLeftOutlined,
      isFullScreen: false,
      prem: true,
    },
    children: [
      {
        path: '/emergencyMan/emergencyRes',
        name: 'emergencyManEmergencyRes',
        component: () => import('@/views/emergencyMan/emergencyRes/index.vue'),
        meta: { title: '应急响应', sort: 1, isFullScreen: false, keepAlive: true, prem: true },
      },
      {
        path: '/emergencyMan/handleEmergencyRes',
        name: 'emergencyManHandleEmergencyRes',
        component: () => import('@/views/emergencyMan/handleEmergencyRes/index.vue'),
        meta: { title: '处理应急事件', sort: 1, isFullScreen: false, keepAlive: false, prem: true },
      },
      // {
      //   path: '/emergencyMan/riskWarning',
      //   name: 'emergencyManRiskWarning',
      //   component: () => import('@/views/emergencyMan/riskWarning/index.vue'),
      //   meta: {
      //     title: '风险提醒',
      //     sort: 2,
      //     isFullScreen: false,
      //     keepAlive: true,
      //     prem: true,
      //   },
      // },
      // 兼容旧风险提醒入口：已迁移到健康管理中心下的新页面，保留旧地址跳转，避免历史收藏/外链失效。
      {
        path: '/emergencyMan/riskWarning',
        name: 'emergencyManRiskWarning',
        redirect: (to: RouteLocationNormalized) => ({
          path: '/health/rescue/orders',
          query: to.query,
        }),
        meta: {
          title: '风险提醒',
          sort: 2,
          isFullScreen: false,
          keepAlive: false,
          hidden: true,
          prem: true,
        },
      },
      {
        path: '/emergencyMan/handleRiskWarning',
        name: 'emergencyManHandleRiskWarning',
        redirect: (to: RouteLocationNormalized) => ({
          path: '/health/rescue/orders',
          query: to.query,
        }),
        meta: {
          title: '处理风险提醒',
          sort: 2,
          isFullScreen: false,
          keepAlive: false,
          hidden: true,
          prem: true,
        },
      },
    ],
  },
]
